import useApi from '../../../services/useApi'
import {useParams} from 'react-router-dom'

const useGetCategoriesDropdown = () => {
  const Api = useApi()
  const {id} = useParams()
  const {data: response, isFetching} = Api.useGetQuery('/products/product-badges/all-categories/dropdown', {
    filters: {
      badge_id: id,
      limit:1000,
    },
  })

  return {
    allCategories: response?.data || [],
    isLoading: isFetching,
  }
}

export default useGetCategoriesDropdown
